import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { HomeschoolingInitiativeComponent } from './homeschooling-initiative/homeschooling-initiative.component';
import { IntroductionToClassicalEducationComponent } from './introduction-to-classical-education/introduction-to-classical-education.component';
import { RecommendedCurriculumComponent } from './recommended-curriculum/recommended-curriculum.component';
var ɵ0 = {
    title: '',
}, ɵ1 = {
    title: 'Introduction to Classical education',
}, ɵ2 = {
    title: 'Recommended Curriculum',
}, ɵ3 = {
    title: 'Homeschooling Initiative',
};
// tslint:disable: max-line-length
var routes = [
    {
        path: '',
        pathMatch: 'full',
        component: HomeComponent,
        data: ɵ0,
    },
    {
        path: 'introduction-to-classical-education',
        pathMatch: 'full',
        component: IntroductionToClassicalEducationComponent,
        data: ɵ1,
    },
    {
        path: 'recommended-curriculum',
        pathMatch: 'full',
        component: RecommendedCurriculumComponent,
        data: ɵ2,
    },
    {
        path: 'homeschooling-initiative',
        pathMatch: 'full',
        component: HomeschoolingInitiativeComponent,
        data: ɵ3,
    },
    {
        path: '**',
        redirectTo: '/'
    }
];
// @ts-ignore
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
